import { render } from "./UsersPage.vue?vue&type=template&id=350edb2c&scoped=true"
import script from "./UsersPage.vue?vue&type=script&lang=js"
export * from "./UsersPage.vue?vue&type=script&lang=js"

import "./UsersPage.vue?vue&type=style&index=0&id=350edb2c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-350edb2c"]])

export default __exports__